// ============================================================
// microsoftPkce.ts — the browser half of PKCE (RFC 7636, S256) for the
// Microsoft connect flow (MicrosoftPanel; microsoftPkce.test.ts).
// A random code_verifier (64 base64url chars) is kept in THIS tab's
// sessionStorage across the redirect to Microsoft and back; only its
// challenge = base64url(SHA-256(verifier)) is sent to the backend first. The
// verifier is read once (and removed) to finish the connection.
// ============================================================
const KEY = 'casevo_ms_pkce_verifier'

const base64url = (bytes: Uint8Array): string => {
  let s = ''
  bytes.forEach((b) => { s += String.fromCharCode(b) })
  return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

export const challengeFor = async (verifier: string): Promise<string> =>
  base64url(new Uint8Array(await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier))))

export const newPkcePair = async (): Promise<{ verifier: string; challenge: string }> => {
  const verifier = base64url(crypto.getRandomValues(new Uint8Array(48))) // 64 chars
  return { verifier, challenge: await challengeFor(verifier) }
}

export const storeVerifier = (verifier: string): void => {
  try { sessionStorage.setItem(KEY, verifier) } catch { /* no storage → the completion will say so */ }
}

// Read once and forget.
export const takeStoredVerifier = (): string | null => {
  try {
    const v = sessionStorage.getItem(KEY)
    sessionStorage.removeItem(KEY)
    return v
  } catch {
    return null
  }
}
